import { Routes } from '@angular/router';
import { Dataset } from './import/component/dataset/dataset';
import { FlowchartSpinner } from './import/component/flowchart-spinner/flowchart-spinner';
import { ListFormatView } from './import/component/list-format/list-format';

export const routes: Routes = [
    {
        path:'',
        redirectTo:'home',
        pathMatch:'full'
    },
    {
        path:'home',
        component: Dataset,
        pathMatch:'full'
    },
    {
        path:'flowChart',
        component: FlowchartSpinner,
        pathMatch:'full'
    },
    {
        path:'listFormat',
        component: ListFormatView,
        pathMatch:'full'
    },
    {
        path:'**',
        redirectTo:'home'
    }
];
